module.exports = __webpack_public_path__ + "static/media/seasi-logo.ebdeb7f6.png";